import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import style from "../../styles/brsr/general.module.css";
import { getRowErrorMessages } from "../../utils/getRowErrorMessage";
import { validateNumber, validateNumberInput, validatePercentage, validatePercentageInput } from "../../utils/validateFields";

const FixedTable = memo(
  ({
    inputData,
    fieldName,
    subHeading,
    tables,
    setTables,
    errors,
    setErrors,
    data,
    tableLength,
    disabled
  }) => {

    useEffect(() => {
      console.log(data)
      setTables((prevTables) => {
        if (fieldName) {
          // Update the specific fieldName in tables
          return {
            ...prevTables,
            [fieldName]: inputData?.map((section) => {
              const existingRows = data?.[section?.fieldName] || []; // Get existing rows or an empty array
              const requiredLength = tableLength || 1; // Ensure a minimum length
              const filledRows = existingRows.slice(0, requiredLength); // Take up to `tableLength` rows
          
              // If existing rows are less than `tableLength`, add empty objects
              const emptyRows = Array.from(
                { length: Math.max(requiredLength - filledRows.length, 0) },
                () => ({})
              );
          
              return {
                fieldName: section?.fieldName,
                rows: [...filledRows, ...emptyRows], // Combine existing and empty rows
              };
            }),
          };
          
        } else {
          // Set tables for all sections in inputData
          return inputData?.map((section) => ({
            fieldName: section?.fieldName,
            rows:
              data?.[section?.fieldName]?.length >= 2
                ? data[section?.fieldName]
                : [{}, {}], // Ensure at least two rows by default
          }));
        }
      });
    }, [data,tableLength]);
    
      
    

    const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
      // Validate based on the field type
      if (type === "percentage" && !validatePercentageInput(value)) return;
      if (type === "number" && !validateNumberInput(value)) return;
    
      // Clone the tables state for immutability
      const updatedTables = [...tables];

      console.log(updatedTables)
      updatedTables[tableIndex].rows[rowIndex][fieldName] = value;
    
      // Update errors by removing the field-specific error if it exists
      const updatedErrors =  { ...errors };
      if (
        updatedErrors[tableIndex] &&
        updatedErrors[tableIndex][rowIndex] &&
        updatedErrors[tableIndex][rowIndex][fieldName]
      ) {
        delete updatedErrors[tableIndex][rowIndex][fieldName];
    
        // Clean up empty objects in the errors structure
        if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
          delete updatedErrors[tableIndex][rowIndex];
        }
        if (Object.keys(updatedErrors[tableIndex]).length === 0) {
          delete updatedErrors[tableIndex];
        }
      }
    
      // Update the state for errors and tables
      setErrors((prev) =>
        fieldName
          ? {
              ...prev,
              [fieldName]: updatedErrors,
            }
          : updatedErrors
      );

      setTables((prev) =>
        fieldName
          ? {
              ...prev,
              [fieldName]: updatedTables,
            }
          : updatedTables
      );
    };
    

    return (
      <Box sx={{ mt: "2rem" }}>
        {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
            <Box sx={{ display: "flex", gap: 1, }}>
              {section?.letter && (
                <p className={style.ques_heading} style={{fontWeight:section.letter==="c."&& 600 }}>{section.letter}</p>
              )}
              <p className={style.ques_heading} style={{fontWeight:section.letter==="c."&& 600 }}>{section.title}</p>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                // mt: 2,
                borderRadius: "10px",
                ml:2.5,
                width:"98%"
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width ,
                          height: "auto",
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                  {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                    console.log(row, "checking row");
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "30px",
                          },
                        }}
                      >
                        <TableCell sx={{textAlign:"center"}}>{rowIndex + 1}.</TableCell>
                        {section?.fields?.map((field) => (
                          <TableCell
                            key={field?.fieldName}
                            sx={{ border: "1px solid #DBDBDB", py: "0.5rem" }}
                          >
                            {field.type === "select" ? (
                              <Select
                                multiple={field?.multiselect}
                                disabled={disabled}
                                value={
                                  field.multiselect
                                    ? row[field?.fieldName] || [] // For multiselect, ensure value is an array
                                    : row[field?.fieldName] || "" // For single select, ensure value is a string
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                displayEmpty
                                fullWidth
                                size="small"
                                sx={{
                                  border: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}
                                renderValue={(selected) =>
                                  field.multiselect && selected.length > 0
                                    ? selected.join(", ")
                                    : field.placeholder || "Select"
                                }
                              >
                                <MenuItem value={""} disabled>
                                  {field.placeholder || "Select"}
                                </MenuItem>
                                {field.options?.map((option, idx) => (
                                  <MenuItem key={idx} value={option}>
                                    {field.multiselect ? (
                                      <>
                                        <Checkbox
                                        disabled={disabled}
                                          checked={
                                            row[field.fieldName]?.includes(
                                              option
                                            ) || false
                                          } // Check if the option is selected
                                          size="small"
                                        />
                                        {option}
                                      </>
                                    ) : (
                                      option
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : field.type === "radio" ? (
                              // console.log(row,row[field.fieldName],"Checking...")
                              <Box sx={{ display: "flex" }}>
                                <FormControl sx={{ my: 1, display: "flex" }}>
                                  <RadioGroup
                                    row
                                    value={row[field.fieldName] || "Yes"}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      handleInputChange(
                                        tableIndex,
                                        rowIndex,
                                        field.fieldName,
                                        e.target.value,
                                        field.type
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      control={<Radio  disabled={disabled}/>}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio disabled={disabled} />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            ) : (
                              <TextField
                                placeholder={field.placeholder}
                                disabled={disabled}
                                type={field.type}
                                value={row[field.fieldName] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                multiline
                                minRows={1}
                                sx={{
                                  width: "100%",
                                  py: "0.5rem",
                                  "& .MuiInputBase-root": {
                                    overflowY: "auto",
                                    cursor: "default", // default cursor
                                  },
                                  "& .MuiInputBase-root:hover": {
                                    cursor: "pointer", // pointer cursor on hover
                                  },
                                }}
                                size="small"
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 1, ml: 2.5 }}>
              {Object.keys(errors).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
            </Box>

            {/* Dynamic error messages for missing fields */}
          </div>
        ))}
      </Box>
    );
  }
);

export default FixedTable;
